<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2025 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->

<div class="insert-link-popup-button">
    <scrm-popup-button [icon]="config?.icon"
                       class="insert-link-button"
                       [klass]="config?.klass"
                       [popoverClass]="''"
                       placement="bottom"
                       [openStatusEventEmitter]="openStatusEventEmitter"
                       [displayButton]="displayButton"
    >
        <div popup-content class="insert-link-popup-body d-flex flex-column container-popover scrollbar-thin p-1">

            <div class="d-flex insert-link-popup-label-row insert-link-popup-row mb-2">
                <scrm-label labelKey="LBL_INSERT_LINK_URL_DESCRIPTION"></scrm-label>
            </div>
            <div class="d-flex insert-link-popup-input-row insert-link-popup-row mb-2">
                <input [(ngModel)]="linkUrl"
                       [class]="inputClass"
                       [placeholder]="this.placeHolderLabel"
                       type="text">
            </div>
            <div *ngIf="config?.items?.length"
                 class="d-flex insert-link-popup-button-row insert-link-popup-row">
                <ng-container *ngFor="let button of buttons">
                    <scrm-button [config]="button"></scrm-button>
                </ng-container>
            </div>
        </div>
    </scrm-popup-button>
</div>
